<template>
  <section class="content-plans-register">
    <Breadcrumb :links="links" :data="this.dataProps"/>
    <form class="content-plans-register-form" @submit.prevent="handleSubmit()">
      <div class="row">
        <div class="col-12 col-lg-6">
          <div class="content-input-default">
            <input type="text" name="name" v-model="meditation.name" value="" placeholder="Nome" required/>
          </div>
        </div>
        <div class="col-12 col-lg-6">
          <div class="content-input-default-select" :class="{'content-input-default-select--active': selectedCategory && selectedCategory !== ''}">
            <select v-model="selectedCategory" required>
              <option value="" selected disabled>Selecione a categoria</option>
              <option v-for="category in meditationCategories" :key="category.id" :value="category.id">{{ category.name }}</option>
            </select>
            <svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg"><mask id="mask0_35_1490" maskUnits="userSpaceOnUse" x="0" y="0" width="7" height="12" style="mask-type: luminance;"><path d="M0.920705 12H7L7 0.543873H0.920705L0.920705 12Z" fill="white"></path></mask><g mask="url(#mask0_35_1490)"><path d="M6.77741 6.84966C7.0742 6.53013 7.0742 6.01118 6.77741 5.69165L2.21883 0.78349C1.92207 0.463963 1.44008 0.463963 1.14331 0.78349C0.846487 1.10307 0.846487 1.62196 1.14331 1.94155L5.16529 6.27191L1.14569 10.6023C0.848868 10.9219 0.848868 11.4408 1.14569 11.7603C1.44246 12.0799 1.92445 12.0799 2.22121 11.7603L6.77979 6.85221L6.77741 6.84966Z" fill="black"></path></g></svg>
          </div>
        </div>
        <div class="col-12">
          <div class="content-input-default">
            <textarea name="description" v-model="meditation.description" value="" placeholder="Descrição curta" style="min-height: 150px" required></textarea>
          </div>
        </div>
        <div class="col-12">
          <UploadImage @changePicture="(value) => meditation.picture = value" :proportion="'Proporção: 400x400'"/>
        </div>
        <div class="col-12">
          <button class="btn-green">Salvar</button>
        </div>
      </div>
    </form>
  </section>
</template>

<script>
import Breadcrumb from '@/components/breadcrumb/Index';
import UploadImage from '@/components/upload/Index';
import { mapGetters, mapActions } from 'vuex';

export default {
  data() {
    return {
      links: [
        {
          name: 'Meditação',
          routerName: 'Meditation'
        },
        {
          name: 'Nova Meditação',
          routerName: 'RegisterMeditation'
        },
      ],
      meditation: {
        id_user: "",
        name: '',
        description: '',
        picture: null,
      },
      quillOptions: {
        placeholder: 'Descreva as informações completa sobre o plano',
        readonly: false,
      },
      meditationParams: this.$route.params,
      selectedCategory: '',
      dataProps: { module: 'Meditation' },
    }
  },
  computed: {
    ...mapGetters({
      user: 'User/user',
      meditationData: 'Meditation/meditation',
      meditationCategories: 'Meditation/meditationCategories',
      isPremium: 'Meditation/isPremium'
    })
  },
  components: {
    Breadcrumb,
    UploadImage
  },
  methods: {
    ...mapActions('Meditation', ['consultCategoriesMeditation', 'registerMeditation', 'consultMeditations', 'setDataDefault']),
    ...mapActions(['setImageFileUrl']),
    async handleSubmit(){
      let message = this.meditation?.id ? 'Meditação editado com sucesso!' : 'Meditação cadastrado com sucesso!';

      this.meditation.id_meditation_category = this.selectedCategory;
      this.meditation.is_premium = this.isPremium;

      await this.registerMeditation(this.meditation);
      this.$router.push({ name: 'Meditation' })
      this.$swal.fire({
        icon: 'success',
        html: message,
      })
    },
  },
  async mounted() {
    this.consultCategoriesMeditation();
    this.meditation.id_user = await this.user.id;
    this.setImageFileUrl(null);
    if (this.meditationParams && Object.keys(this.meditationParams).length > 0) {
      await this.consultMeditations(this.meditationParams);
      this.dataProps = {
        name: this.meditationData.name,
        id: this.meditationParams.id,
        module: 'Meditation',
        type: 'Meditation'
      };
      this.meditation = this.meditationData;
      this.setDataDefault(['SET_IS_PREMIUM', this.meditation.is_premium]);
      this.selectedCategory = this.meditation.id_meditation_category;
      this.links[1].name = this.meditation.name;
      this.setImageFileUrl(this.meditation.picture);
    }
  }
}
</script>

<style lang="scss" scoped>
.content-plans-register {
  padding-bottom: 50px;
}
.content-input-default {
  textarea {
    min-height: 250px;
  }
}
.btn-green {
  margin-top: 100px;
  @media (max-width: 991px){
    margin-top: 50px;
  }
}
</style>
